import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GanttCharts } from "../../../../Constant";
import { GANTT_CHART_DATA, GANTT_CHART_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const GanttChart = () => {
  return (
    <Col sm="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={GanttCharts} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="gantt_chart">
            <Chart chartType="Gantt" width="100%" height="280px" data={GANTT_CHART_DATA} options={GANTT_CHART_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GanttChart;
